/**
 * Labstep
 *
 * @module components/OrderRequest/ShowEdit/PurchaseOrder
 * @desc ShowEdit for setting purchase order for an order request
 */

import { useHasAccess } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { EntityLink } from 'labstep-web/components/Entity/Link';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { FormShowEditSearchSelect } from 'labstep-web/core/Form/ShowEdit/SearchSelect';
import { PurchaseOrder } from 'labstep-web/models/purchase-order.model';
import type React from 'react';
import type { OrderRequestFormShowEditPurchaseOrderProps } from './types';

export const OrderRequestFormShowEditPurchaseOrder: React.FC<
  OrderRequestFormShowEditPurchaseOrderProps
> = ({ orderRequest, activeGroup, showIcon }) => {
  const canEdit = useHasAccess(
    orderRequest.entityName,
    orderRequest.id,
    Action.edit,
  );
  return (
    <FormShowEditSearchSelect
      placeholder="Add to order"
      childEntityName={PurchaseOrder.entityName}
      parentEntity={orderRequest}
      searchSelectProps={{
        params: {
          status: 'open',
          group_id: activeGroup?.id,
        },
        createBody: { currency: orderRequest.currency },
        creatable: true,
        allowCreateWithEmptyInput: true,
      }}
      disabled={!(orderRequest.canSetPurchaseOrder && canEdit)}
      customShow={() =>
        orderRequest.purchase_order && (
          <EntityLink
            entity={orderRequest.purchase_order}
            secondary
            showIcon={showIcon}
          />
        )
      }
    >
      {orderRequest.purchase_order && (
        <EntityLink
          entity={orderRequest.purchase_order}
          secondary
          showIcon={showIcon}
        />
      )}
    </FormShowEditSearchSelect>
  );
};

export default withActiveGroup(OrderRequestFormShowEditPurchaseOrder);
